export default "/images/c873d3835886814ca69b4bd8e1e34ab1.avif";